module.exports = __webpack_public_path__ + "static/media/logos_mobile.a7dd1f34.webp";